module.exports = __webpack_public_path__ + "static/media/start-right_1.62ae78c6.svg";